import type { ComponentProps, FC } from 'react';

import { Box, Expandable, InputSelect, Stack } from '@eneco/sparky';
import { getClassNames } from '@eneco/sparky/util/css';

import {
  adviceCardImageContainerClass,
  sentenceContainerClass,
  styledInputSelectClass,
  tipCardContainerClass,
  triggerClass,
} from './InspirationAdviceFilter.css';

export const AdviceCardImageContainer: FC<ComponentProps<typeof Box>> = ({ className, ...props }) => (
  <Box className={getClassNames(adviceCardImageContainerClass, className)} {...props} />
);

export const SentenceContainer = (props: ComponentProps<typeof Stack>) => (
  <Stack className={sentenceContainerClass} {...props} />
);

export const StyledInputSelect: FC<ComponentProps<typeof InputSelect>> = ({ className, ...props }) => (
  <InputSelect className={getClassNames(styledInputSelectClass, className)} {...props} />
);

export const TipCardContainer: FC<ComponentProps<typeof Box>> = ({ className, ...props }) => (
  <Box className={getClassNames(tipCardContainerClass, className)} {...props} />
);

export const Trigger: FC<ComponentProps<typeof Expandable.Trigger>> = ({ className, ...props }) => (
  <Expandable.Trigger className={getClassNames(triggerClass, className)} {...props} />
);

AdviceCardImageContainer.displayName = 'AdviceCardImageContainer';
SentenceContainer.displayName = 'SentenceContainer';
StyledInputSelect.displayName = 'StyledInputSelect';
TipCardContainer.displayName = 'TipCardContainer';
Trigger.displayName = 'LoaderContainer';
